
import { createSlice } from "@reduxjs/toolkit";

const initialState: any = {
    message: { title: null, description: null }
};

export const toastReducer = createSlice({
    name: "toast",
    initialState,
    reducers: {
        showMessage: (state, action) => {
            state.message = action.payload;

        },
        hideToastMessage: (state) => {
            state.message.title = '';
            state.message.description = '';
            state.message.isOpen = false
        },

    },
});

export const { showMessage, hideToastMessage } = toastReducer.actions;
export default toastReducer.reducer;

